"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bubble = exports.List = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.List = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexWrap: "wrap",
    variants: {
        hasTooltip: {
            true: {
                width: "100%",
            },
        },
    },
});
exports.Bubble = (0, stitches_config_1.styled)("div", {
    border: stitches_config_1.borderStyles.solid,
    borderRadius: "16px",
    fontSize: stitches_config_1.fontSizes.body4,
    cursor: "pointer",
    padding: "5px 10px",
    marginRight: "10px",
    marginBottom: "7px",
    variants: {
        selected: {
            true: {
                backgroundColor: stitches_config_1.colors.blue500,
                color: stitches_config_1.colors.contentPrimaryInverted,
                "&:hover": {
                    backgroundColor: stitches_config_1.colors.blue500,
                },
            },
        },
        disabled: {
            true: {
                cursor: "default",
            },
        },
        readonly: {
            true: {
                cursor: "default",
            },
        },
    },
    compoundVariants: [
        {
            selected: false,
            readonly: true,
            css: {
                opacity: "60%",
            },
        },
        {
            disabled: true,
            readonly: false,
            css: {
                opacity: "60%",
            },
        },
    ],
});
//# sourceMappingURL=data:application/json;base64,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